// Module
var code = "<a href=\"javascript:;\" class=\"text-sm sps-btn sps-btn-outline btn-color-edit edit-button\"> <i class=\"fa fa-edit\"></i><span data-bind=\"text: _labels.EDIT\"></span> </a>";
// Exports
export default code;